import React from 'react';
import { AppSessionData } from 'src/constants/dataTypes/sessionDataTypes';

export type SessionData = {
  portalIdToSession: Record<string, AppSessionData>;
  currentPortalSession: string;
};

export const RouteContext = React.createContext({
  pathname: '/',
  query: {},
  isMobile: false,
  sessionData: {
    portalIdToSession: {},
    currentPortalSession: '',
  } as SessionData,
});
